import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const probateEstateAssetsApi = createApi({
  reducerPath: "probateEstateAssetsApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["ProbateEstateAsset"],
  endpoints: (build) => ({
    getAllEstateAssets: build.query({
      query: ({ caseId, kind, limit = 2000 } = {}) => ({
        url: "/probate/estate-assets",
        method: "GET",
        params: { caseId, kind, limit },
      }),
      providesTags: ["ProbateEstateAsset"],
    }),
    createEstateAsset: build.mutation({
      query: (data) => ({ url: "/probate/estate-assets", method: "POST", body: data }),
      invalidatesTags: ["ProbateEstateAsset"],
    }),
    updateEstateAsset: build.mutation({
      query: ({ id, ...data }) => ({ url: `/probate/estate-assets/${id}`, method: "PUT", body: data }),
      invalidatesTags: ["ProbateEstateAsset"],
    }),
    deleteEstateAsset: build.mutation({
      query: (id) => ({ url: `/probate/estate-assets/${id}`, method: "DELETE" }),
      invalidatesTags: ["ProbateEstateAsset"],
    }),
  }),
});

export const {
  useGetAllEstateAssetsQuery,
  useCreateEstateAssetMutation,
  useUpdateEstateAssetMutation,
  useDeleteEstateAssetMutation,
} = probateEstateAssetsApi;
